module.exports = __webpack_public_path__ + "static/media/9DESA17.db832a86.jpg";